// extracted by mini-css-extract-plugin
export default {"scrollBar":"vip-promos_scrollBar__SMXxF","textAreaScroll":"vip-promos_textAreaScroll__3wwRr","list":"vip-promos_list__aw7SL vip-promos_scrollBar__SMXxF"};